export { WithCtaOnImageSideVariation as default } from './WithCtaOnImageSideVariation';
